// src/components/FilterBar.js

import React from 'react';

function FilterBar({ searchQuery, setSearchQuery, category, setCategory, location, setLocation, type, setType }) {
    const clearFilters = () => {
        setSearchQuery('');
        setCategory('');
        setLocation('');
        setType('');
    };

    const hasActiveFilters = searchQuery || category || location || type;

    return (
        <div className="filter-bar">
            <input 
                type="search" 
                placeholder="Search jobs, category, or location..." 
                value={searchQuery} 
                onChange={(e) => setSearchQuery(e.target.value)} 
            />
            <select value={category} onChange={(e) => setCategory(e.target.value)}>
                <option value="">All Job Categories</option>
                <option value="IT">IT</option>
                <option value="Finance">Finance</option>
            </select>
            <select value={location} onChange={(e) => setLocation(e.target.value)}>
                <option value="">All Job Locations</option>
                <option value="Mumbai">Mumbai</option>
                <option value="Andheri">Andheri</option>
                <option value="Pune">Pune</option>
            </select>
            <select value={type} onChange={(e) => setType(e.target.value)}>
                <option value="">All Job Types</option>
                <option value="Full-time">Full-time</option>
                <option value="Part-time">Part-time</option>
            </select>
            {hasActiveFilters && (
                <button className="clear-filters-btn" onClick={clearFilters} type="button">
                    Clear Filters
                </button>
            )}
        </div>
    );
}

export default FilterBar;
